<template>
    <div class="Copyright-Container">
        <p>更多疑问咨询：前往微博私信<a rel="noopener" @click="contact" href="https://weibo.com/u/6193090141">雪谋</a>。</p>
        <hr/>
        <p>Copyright © {{ year }} YukiHakarigoto. 保留所有权利。</p>
    </div>
</template>

<script>
  export default {
    computed: {
        year: { // 自动显示当前年份
            get: function () {
            return new Date().getFullYear()
            }
        }
    },
    methods: {
        contact() {
            this.$ga.event('contact', 'visit', 'weibo', 1)
            },
        },
  }
</script>

<style lang="stylus" scoped>
.Copyright-Container{
    padding: 40px;
}
hr{
    height:1px;
    border:none;
    background: #D6D6D6;
    margin-top: 12px;
    margin-bottom: 12px;
}
p{
    text-align:left;
    font-size: 14px;
    word-spacing: 3px;
    color: #888888;
    margin: 0px;
}
    @media (max-width: 600px){
        .Copyright-Container{
            padding: 20px;
            padding-bottom: 30px;
        }
        hr{
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }
</style>